import(/* webpackMode: "eager" */ "/opt/apps/wisprs/src/app/error.tsx");
